import React from "react";
import Logo from "../media/logo.svg";
import { Link } from "react-router-dom";

const PasswordRecovery = () => {
  return (
    <>
      <div>
        <img
          src={Logo}
          className="w-52 m-auto mt-8 mb-12 md:mmt-4 md:mb-24"
          alt="Club La Voz"
        />
      </div>
      <form action="POST" className="max-w-md mx-8 md:mx-16 mt-4 md:mt-11 mb-4">
        <div>
          <h3 className="text-center font-body text-gray-900 font-bold text-2xl pt-4 pb-2">
            Editar Perfil
          </h3>
          <div className="my-4">
            <label className="font-body font-normal">
              Correo electrónico de renovación/recuperación de contraseña
            </label>
            <input
              type="text"
              className="w-full my-2 pl-5 py-2 rounded-full border border-gray-500 bg-[#fff] placeholder-gray-500 font-normal font-body focus:rounded-full  focus:bg-neutral-50 focus:border-clvblue"
              placeholder="Correo Electronico"
            />
          </div>
          <div className="my-4">
            <label className="font-body font-normal">Nueva contraseña</label>
            <input
              type="text"
              className="w-full my-2 pl-5 py-2 rounded-full border border-gray-500 bg-[#fff] placeholder-gray-500 font-normal font-body focus:rounded-full  focus:bg-neutral-50 focus:border-clvblue"
              placeholder="Nueva contraseña"
            />
          </div>
          <div className="my-4">
            <label className="font-body font-normal">
              Confirmar nueva contraseña
            </label>
            <input
              type="text"
              className="w-full my-2 pl-5 py-2 rounded-full border border-gray-500 bg-[#fff] placeholder-gray-500 font-normal font-body focus:rounded-full  focus:bg-neutral-50 focus:border-clvblue"
              placeholder="Repetir contraseña"
            />
          </div>
          <div className="mt-2 mb-4 w-full flex flex-row justify-around items-center">
            <Link to={"/"}>
              <button className="w-56 h-10 flex justify-center items-center px-4 py-1 mr-2 border border-clvblue rounded-full text-clvblue text-xl font-body font-bold">
                Cancelar
              </button>
            </Link>
            <input
              type="submit"
              className="w-56 h-10 flex justify-center items-center ml-2 px-4 py-1 bg-clvblue border-0 rounded-full text-gray-50 text-xl font-body font-bold hover:bg-[#C2CBDF] hover:border-2 hover:border-clvblue hover:text-clvblue"
              value="Actualizar Datos"
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default PasswordRecovery;
